import React from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Typography,
  Box,
  Alert,
} from "@mui/material";
import { Warning as WarningIcon } from "@mui/icons-material";

const DeleteDialog = ({ open, onClose, onConfirm, deletingData, isLoading }) => {
  const handleConfirm = () => {
    if (onConfirm && deletingData) {
      onConfirm();
    }
  };

  return (
    <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
      <DialogTitle>
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
          <WarningIcon color="error" />
          <Typography variant="h6">Confirm Delete</Typography>
        </Box>
      </DialogTitle>
      <DialogContent>
        <Alert severity="warning" sx={{ mb: 2 }}>
          This action cannot be undone. The rector comment will be permanently deleted.
        </Alert>
        <Typography variant="body1" gutterBottom>
          Are you sure you want to delete this rector comment?
        </Typography>
        {deletingData && (
          <Box sx={{ mt: 2, p: 2, bgcolor: 'grey.100', borderRadius: 1 }}>
            <Typography variant="body2" color="text.secondary">
              <strong>Term:</strong> {deletingData.termName || deletingData.term?.termName || "N/A"}
            </Typography>
            {deletingData.rectorComments && (
              <Typography 
                variant="body2" 
                color="text.secondary" 
                sx={{ mt: 1 }}
                dangerouslySetInnerHTML={{
                  __html: deletingData.rectorComments.length > 200
                    ? deletingData.rectorComments.substring(0, 200) + "..."
                    : deletingData.rectorComments
                }}
              />
            )}
          </Box>
        )}
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} color="secondary" disabled={isLoading}>
          Cancel
        </Button>
        <Button
          onClick={handleConfirm}
          variant="contained"
          color="error"
          disabled={isLoading}
        >
          {isLoading ? "Deleting..." : "Delete"}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default DeleteDialog;

